<mat-icon class="m-l" (click)="CloseDialog()">clear</mat-icon>
<div class="align-center">
  <span mat-dialog-content>
    Your password will expire in {{passwordExpirydate}} day(s). For security purposes, if you do not
    change your password, you
    will not be able to connect to {{portalName}}. Please use the
    <a class="simple-link" routerLink="change-password" (click)="gochangepasswordComponent()">Change password</a>
    feature to update it.
  </span>
</div>